import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Mapackageitem = ()=>{
    const [mapackageitem, setMapackageitem] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`mapackageitem?page=${page}`);
            setMapackageitem(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`mapackageitem/${id}`);
            setMapackageitem(mapackageitem.filter((mapackageitem) => mapackageitem.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Mapackageitem'}>
            <InnerNav createLink={'/mapackageitemCreate'} listLink={'/mapackageitem'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Matravelpackage </th>
                                    <th className="px-4 py-3">Item </th>
                                    <th className="px-4 py-3">Qty </th>
                                    <th className="px-4 py-3">UnitPrice </th>
                                    <th className="px-4 py-3">Total </th>
                                    <th className="px-4 py-3">TimeIn </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {mapackageitem && mapackageitem.length > 0 ? (
                                         mapackageitem.map((mapackageitem)=>(
                                             <tr key={mapackageitem.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{mapackageitem.id}</td>
                                                 <td className="px-4 py-3 text-sm">{mapackageitem.ma_travel_package.name}</td>
                                                 <td className="px-4 py-3 text-sm">{mapackageitem.item}</td>
                                                 <td className="px-4 py-3 text-sm">{mapackageitem.qty}</td>
                                                 <td className="px-4 py-3 text-sm">{mapackageitem.unit_price}</td>
                                                 <td className="px-4 py-3 text-sm">{mapackageitem.total}</td>
                                                 <td className="px-4 py-3 text-sm">{mapackageitem.time_in}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/mapackageitem/${mapackageitem.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(mapackageitem.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         ))
                                ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center py-5 text-gray-500">No data to display </td>
                                            </tr>
                                         )}
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Mapackageitem;